import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'
import versionInfo from '@/version.json'
import { CalendarClock } from 'lucide-react'

interface AppVersionDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const AppVersionDialog = ({
  open,
  onOpenChange,
}: AppVersionDialogProps) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side='bottom' className='h-fit p-2'>
        <SheetHeader>
          <SheetTitle className='text-center text-base'>
            Phiên bản:{' '}
            <span className='font-semibold uppercase text-primary'>
              {versionInfo.version}
            </span>
          </SheetTitle>
        </SheetHeader>
        <div className='flex items-center justify-center gap-1.5 py-1 text-center text-sm text-muted-foreground'>
          <span className='font-semibold text-primary'>
            {versionInfo.environment}
          </span>
          <span className='text-muted-foreground'>
            #{versionInfo.buildNumber}
          </span>
          <span>•</span>
          <CalendarClock className='h-2.5 w-2.5' />
          <span className='text-muted-foreground'>{versionInfo.buildDate}</span>
        </div>
      </SheetContent>
    </Sheet>
  )
}
